<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>预算科目</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.remark">
                <el-input v-model="remark" placeholder="请输入备注" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.label">
                <el-input v-model="label" placeholder="请输入标签" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.type">
                <el-select clearable filterable v-model="type" placeholder="请选择预算科目类型">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.principal_rid">
                <el-select
                    style="width: 100%"
                    v-model="principal_rid"
                    filterable
                    reserve-keyword
                    placeholder="请选择负责人"
                    size="mini"
                    clearable
                >
                    <el-option v-for="item in principalOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.assistance">
                <el-select clearable filterable v-model="assistance" placeholder="请选择辅助类型">
                    <el-option v-for="item in assistanceOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.accounting_attribute">
                <el-select clearable filterable v-model="accounting_attribute" placeholder="请选择会计属性">
                    <el-option v-for="item in accountingOptinn" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.status">
                <el-select clearable filterable v-model="status" placeholder="请选择状态">
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.department_rid">
                <el-select clearable filterable v-model="department_rid" placeholder="请选择部门">
                    <el-option v-for="item in departmentOptions" :key="item.rid" :label="item.name + '-' + item.code" :value="item.rid">
                    </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.budget_object_rid">
                <el-select
                    style="width: 100%"
                    v-model="budget_object_rid"
                    filterable
                    reserve-keyword
                    placeholder="请选择预算对象"
                    size="mini"
                    clearable
                >
                    <el-option v-for="item in budgetOptions" :key="item.rid" :label="item.full_name" :value="item.rid"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增预算科目</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >

                    <crm-upload obj="budget_subject"></crm-upload>

                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="budget_subject"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    item.prop == 'code' ||
                                    item.prop == 'name' ||
                                    item.prop == 'principal_name' ||
                                    item.prop == 'department_name'
                                "
                            >
                                <el-link type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
crmUpload;
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'budgetAccountListComponent',
    data() {
        return {
            draggable: {
                data_name: 'budget_subject'
            },
            code: '',
            name: '',
            remark: '',
            label: '',
            type: '',
            principal_rid: '',
            assistance: '',
            accounting_attribute: '',
            status: '',
            department_rid: '',
            budget_object_rid: '',
            down_loading: false,
            loading: false,
            typeOptions: [],
            principalOptions: [],
            assistanceOptions: [],
            accountingOptinn: [],
            //状态
            statusOptions: [
                {
                    name: '启用',
                    value: 1
                },
                {
                    name: '禁用',
                    value: 2
                }
            ],
            departmentOptions: [],
            budgetOptions: [],
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            postList1: {}
        };
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.budget_object_rid) {
                        this.budget_object_rid = newValue.params.budget_object_rid;
                        this.getList(0); //获取列表
                    }
                }
            },
            deep: true
        }
    },
    props: {
        postList: {
            type: Object
        }
    },

    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['budgetAccount_params']) {
                this.page = paramsList['budgetAccount_params'].page;
                this.row = paramsList['budgetAccount_params'].row;
                this.name = paramsList['budgetAccount_params'].name;
                // this.data_name = paramsList['budgetAccount_params'].data_name;
                // this.sort = paramsList['budgetAccount_params'].sort;
                this.code = paramsList['budgetAccount_params'].code;
                this.label = paramsList['budgetAccount_params'].label;
                this.remark = paramsList['budgetAccount_params'].remark;
                this.budget_object_rid = paramsList['budgetAccount_params'].budget_object_rid;
                this.principal_rid = paramsList['budgetAccount_params'].principal_rid;
                this.assistance = paramsList['budgetAccount_params'].assistance;
                this.department_rid = paramsList['budgetAccount_params'].department_rid;
                this.status = paramsList['budgetAccount_params'].status;
                this.type = paramsList['budgetAccount_params'].type;
                this.accounting_attribute = paramsList['budgetAccount_params'].accounting_attribute;
            }
        }
    },
    mounted() {
        // bus.$off('update');
        // var that = this;
        // bus.$on('update', function (msg) {
        //     that.postList1.params.budget_object_rid = msg;
        // });
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getList(0); //获取列表
                this.remotePrincipal(); //获取负责人方法
                this.remoteType(); //预算科目类型
                this.remoteAssistance(); //辅助类型方法
                this.remoteDepartment(); //部门下拉方法
                this.remoteAccounting(); //会计属性
                this.getBudget(); //获取预算对象
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('budget_subject', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).budget_subject;
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(row) {
            var params = {
                id: row
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .budgetSubjectDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });

                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetAccount_params']) {
                    newParamsList['budgetAccount_params'].data_name = val.prop;
                    newParamsList['budgetAccount_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //新增
        addAcount() {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                this.$router.push({
                    path: '/budgetAccountDetails',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'principal_name') {
                this.$router.push({
                    path: '/adminDetail',
                    query: {
                        id: row.principal_rid
                    }
                });
            } else if (prop == 'department_name') {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: row.department_rid
                    }
                });
            }
        },
        //获取预算对象
        getBudget() {
            let params = {};
            this.$api
                .dropdownBudgetObject(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.budgetOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //会计属性
        remoteAccounting() {
            let params = {};
            this.$api
                .budgetSubjectAccountingAttribute(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.accountingOptinn = res.data;
                    }
                })
                .catch((error) => {});
        },
        //辅助类型方法
        remoteAssistance() {
            let params = {};
            this.$api
                .budgetSubjectAssistance(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.assistanceOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //预算科目类型
        remoteType() {
            let params = {};
            this.$api
                .budgetSubjectType(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.typeOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //部门下拉方法
        remoteDepartment() {
            let params = {
                all_status: 1
            };
            this.$api
                .budgetDepartment(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.departmentOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取负责人方法
        remotePrincipal() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.principalOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                is_export: type_data,
                sort: [this.data_name, this.sort],
                code: this.code,
                name: this.name,
                label: this.label,
                remark: this.remark,
                budget_object_rid: this.budget_object_rid,
                principal_rid: this.principal_rid,
                assistance: this.assistance,
                department_rid: this.department_rid,
                status: this.status,
                type: this.type,
                accounting_attribute: this.accounting_attribute
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['budgetAccount_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .budgetSubjectLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['budgetAccount_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .budgetSubjectListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },

        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetAccount_params']) {
                    newParamsList['budgetAccount_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        code: this.code,
                        name: this.name,
                        label: this.label,
                        remark: this.remark,
                        budget_object_rid: this.budget_object_rid,
                        principal_rid: this.principal_rid,
                        assistance: this.assistance,
                        department_rid: this.department_rid,
                        status: this.status,
                        type: this.type,
                        accounting_attribute: this.accounting_attribute
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetAccount_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },

        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['budgetAccount_params']) {
                    newParamsList['budgetAccount_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        sort: [this.data_name, this.sort],
                        code: this.code,
                        name: this.name,
                        label: this.label,
                        remark: this.remark,
                        budget_object_rid: this.budget_object_rid,
                        principal_rid: this.principal_rid,
                        assistance: this.assistance,
                        department_rid: this.department_rid,
                        status: this.status,
                        type: this.type,
                        accounting_attribute: this.accounting_attribute
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['budgetAccount_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }

            this.getList(0);
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.name = '';
            this.label = '';
            this.remark = '';
            this.principal_rid = '';
            this.budget_object_rid = '';
            this.page = 1;
            this.row = 25;
            this.assistance = '';
            this.department_rid = '';
            this.status = '';
            this.type = '';
            this.accounting_attribute = '';

            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                code: '',
                name: '',
                label: '',
                remark: '',
                principal_rid: '',
                budget_object_rid: '',
                assistance: '',
                department_rid: '',
                status: '',
                type: '',
                accounting_attribute: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['budgetAccount_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
// 让“暂无数据”文本居中显示
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>